import React from 'react';
import IframePage from './IframePage';

export default function PresentationEcolunchPage() {
  return (
    <IframePage
      title="Présentation EcoLunch"
      url="https://expli.ecotechsystem.ca"
    />
  );
}
